export default Object.freeze({
    DEFAULT: Symbol('DEFAULT'),
    DND_SOURCE: Symbol('DND_SOURCE'),
    DND_TARGET: Symbol('DND_TARGET')
})
